<template>
  <div class="lengend">
    <img src="~images/index/home/ydym.png" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="stylus" scoped>
.lengend
  position absolute
  color #fff
  right calc(28% - 10px)
  z-index 1
  top 45%
  padding 2px
  font-size 0.08rem
</style>
